/**
 * Checks if the provided value is of type number.
 *
 * @param value - The value to check.
 * @returns True if the value is a number, otherwise false.
 */
export const isNumber = (value: unknown): value is number =>
  typeof value === "number" && !Number.isNaN(value);
